"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToExtendedVesselHatchActivity = exports.sortVesselHatchActivities = exports.findVesselHatchGroup1EndDate = exports.findVesselHatchGroupEndDate = exports.findVesselHatchGroupStartDate1 = exports.findVesselHatchGroupStartDate = exports.findVesselHatchGroupDurations = exports.findVesselHatchGroupDirectLoadingDuration = exports.findVesselHatchGroupStockpileDuration = void 0;
const moment_1 = __importDefault(require("moment"));
function findVesselHatchGroupStockpileDuration(activities) {
    let duration = 0;
    for (const activity of activities) {
        if (activity.hatchLoadingActivity) {
            const loadingDuration = moment_1.default
                .duration(moment_1.default(activity.endDate).diff(moment_1.default(activity.startDate)))
                .asMinutes();
            duration += loadingDuration;
        }
    }
    return duration;
}
exports.findVesselHatchGroupStockpileDuration = findVesselHatchGroupStockpileDuration;
function findVesselHatchGroupDirectLoadingDuration(activities) {
    let duration = 0;
    for (const activity of activities) {
        if (activity.hatchDirectLoadingActivity) {
            const directLoadingDuration = moment_1.default
                .duration(moment_1.default(activity.endDate).diff(moment_1.default(activity.startDate)))
                .asMinutes();
            duration += directLoadingDuration;
        }
    }
    return duration;
}
exports.findVesselHatchGroupDirectLoadingDuration = findVesselHatchGroupDirectLoadingDuration;
function findVesselHatchGroupDurations(activities) {
    let duration = 0;
    for (const activity of activities) {
        if (activity.hatchDirectLoadingActivity || activity.hatchLoadingActivity) {
            const directLoadingDuration = moment_1.default
                .duration(moment_1.default(activity.endDate).diff(moment_1.default(activity.startDate)))
                .asMinutes();
            duration += directLoadingDuration;
        }
    }
    return duration;
}
exports.findVesselHatchGroupDurations = findVesselHatchGroupDurations;
function findVesselHatchGroupStartDate(activity) {
    return moment_1.default(activity.startDate);
}
exports.findVesselHatchGroupStartDate = findVesselHatchGroupStartDate;
function findVesselHatchGroupStartDate1(activities) {
    if (activities.length === 0) {
        return moment_1.default();
    }
    let startDate = null;
    const l = activities[activities.length - 1];
    if (l) {
        startDate = findVesselHatchGroupStartDate(l);
    }
    if (startDate === null) {
        //this will happen when a hatch group is not finished
        //this should never occur if the hatch group finished checks is done
        startDate = moment_1.default();
    }
    return startDate;
}
exports.findVesselHatchGroupStartDate1 = findVesselHatchGroupStartDate1;
function findVesselHatchGroupEndDate(activity) {
    return moment_1.default(activity.endDate);
}
exports.findVesselHatchGroupEndDate = findVesselHatchGroupEndDate;
function findVesselHatchGroup1EndDate(activities) {
    let endDate = null;
    //find activity type
    const l = activities[activities.length - 1];
    if (l) {
        endDate = findVesselHatchGroupEndDate(l);
    }
    if (endDate === null) {
        //this will happen when a hatch group is not finished
        //this should never occur if the hatch group finished checks is done
        endDate = moment_1.default();
    }
    return endDate;
}
exports.findVesselHatchGroup1EndDate = findVesselHatchGroup1EndDate;
function sortVesselHatchActivities(vesselHatchActivityGroup) {
    var _a;
    return Object.values((_a = vesselHatchActivityGroup === null || vesselHatchActivityGroup === void 0 ? void 0 : vesselHatchActivityGroup.activities) !== null && _a !== void 0 ? _a : {}).sort((vesselActivityA, vesselActivityB) => {
        const ma = findVesselHatchGroupStartDate(vesselActivityA);
        const mb = findVesselHatchGroupStartDate(vesselActivityB);
        if (ma && mb) {
            const isAfter = ma.isBefore(mb);
            const isEqual = ma.isSame(mb, 'minute');
            if (isAfter) {
                return -1;
            }
            else if (isEqual) {
                return 0;
            }
            else {
                return 1;
            }
        }
        else {
            throw new Error('a date is undefined');
        }
    });
}
exports.sortVesselHatchActivities = sortVesselHatchActivities;
function convertToExtendedVesselHatchActivity(vesselHatchActivities) {
    const h = [];
    for (let i = 0; i < vesselHatchActivities.length; i++) {
        const one = vesselHatchActivities[i];
        const two = vesselHatchActivities[i + 1];
        if (one && two) {
            if (findVesselHatchGroupEndDate(one).isSame(findVesselHatchGroupStartDate(two), 'minute')) {
                h.push({ ...one, unAllocatedTime: undefined });
            }
            else {
                h.push({ ...one, unAllocatedTime: undefined });
                h.push({
                    id: '',
                    startDate: findVesselHatchGroupEndDate(one).toDate(),
                    endDate: findVesselHatchGroupStartDate(two).toDate(),
                    unAllocatedTime: {},
                });
            }
        }
        else {
            h.push({ ...one, unAllocatedTime: undefined });
        }
    }
    return h;
}
exports.convertToExtendedVesselHatchActivity = convertToExtendedVesselHatchActivity;
